import * as Oauth from './auth-provider-methods';

export default Oauth;
